import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AddCircle14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_9)'>
      <path
        d='M6.25 10V7.75H4V6.25H6.25V4H7.75V6.25H10V7.75H7.75V10H6.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 0.249939C3.27208 0.249939 0.25 3.27202 0.25 6.99994C0.25 10.7279 3.27208 13.7499 7 13.7499C10.7279 13.7499 13.75 10.7279 13.75 6.99994C13.75 3.27202 10.7279 0.249939 7 0.249939ZM1.75 6.99994C1.75 4.10044 4.1005 1.74994 7 1.74994C9.8995 1.74994 12.25 4.10044 12.25 6.99994C12.25 9.89943 9.8995 12.2499 7 12.2499C4.1005 12.2499 1.75 9.89943 1.75 6.99994Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_9'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AddCircle14.displayName = 'AddCircle14';
export default AddCircle14;
